var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "home page-wrapper" }, [
    _c("div", { staticClass: "container-xl" }, [
      _c("div", { staticClass: "page-header d-print-none" }, [
        _c("div", { staticClass: "row align-items-center" }, [
          _c("div", { staticClass: "col" }, [
            _c("div", { staticClass: "page-pretitle" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$auth.activeCompany
                      ? _vm.$auth.activeCompany.companyName
                      : ""
                  ) +
                  " "
              ),
            ]),
            _c("h2", { staticClass: "page-title" }, [
              _vm._v("Graphical Ad Report"),
            ]),
          ]),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "page-body" }, [
      _vm.loaded
        ? _c("div", { staticClass: "container-xl" }, [
            !_vm.$auth.isFeatured
              ? _c("div", { staticClass: "row mb-3" }, [
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c("upgrade-to-access", [
                        _c("p", [
                          _vm._v(
                            " Upgrade to a featured listing to purchase and view reports on display advertising. "
                          ),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ])
              : _c("div", { staticClass: "row row-deck row-cards" }, [
                  _c("div", { staticClass: "col col-lg-3" }, [
                    _c(
                      "form",
                      { attrs: { action: "", method: "get" } },
                      [
                        _c("site-select", {
                          attrs: { "all-sites": _vm.sites_map },
                          on: { "update:selected": _vm.updateSelectedSites },
                        }),
                        _c("date-filters", {
                          attrs: {
                            "all-filters": _vm.date_filters,
                            bus: this.filter.selected_datefilter,
                          },
                          on: {
                            "update:selected": _vm.updateSelectedDateFilter,
                          },
                        }),
                        _vm.custom
                          ? _c(
                              "div",
                              [
                                _c("date-select", {
                                  attrs: { label: "Start Date" },
                                  on: {
                                    "update:selected":
                                      _vm.updateSelectedStartDate,
                                  },
                                }),
                                _c("date-select", {
                                  attrs: { label: "End Date" },
                                  on: {
                                    "update:selected":
                                      _vm.updateSelectedEndDate,
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.$auth.ignoreDemo.isFeatured
                          ? _c("div", [
                              _c("div", { staticClass: "subheader mb-2" }, [
                                _vm._v("Export"),
                              ]),
                              _c("div", { staticClass: "mb-3" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-primary w-100",
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.generateCSV()
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "svg",
                                      {
                                        staticClass:
                                          "icon icon-tabler icon-tabler-table-export",
                                        attrs: {
                                          xmlns: "http://www.w3.org/2000/svg",
                                          width: "24",
                                          height: "24",
                                          viewBox: "0 0 24 24",
                                          "stroke-width": "2",
                                          stroke: "currentColor",
                                          fill: "none",
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round",
                                        },
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            stroke: "none",
                                            d: "M0 0h24v24H0z",
                                            fill: "none",
                                          },
                                        }),
                                        _c("path", {
                                          attrs: {
                                            d: "M11.5 20h-5.5a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v7.5m-16 -3.5h16m-10 -6v16m4 -1h7m-3 -3l3 3l-3 3",
                                          },
                                        }),
                                      ]
                                    ),
                                    _vm._v(" Download as CSV "),
                                  ]
                                ),
                              ]),
                            ])
                          : _vm._e(),
                        _vm.reload
                          ? _c("div", [
                              _c("div", {
                                staticClass: "spinner-border mt-2",
                                attrs: { role: "status" },
                              }),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "col-lg-9" }, [
                    _vm.graphicaladDTOs.length > 0
                      ? _c("div", { staticClass: "container-xl" }, [
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col" }, [
                              _c(
                                "div",
                                { staticClass: "d-flex justify-content-end" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "subheader mb-2",
                                      attrs: { id: "topOftable" },
                                    },
                                    [
                                      _vm._v(
                                        " Showing " +
                                          _vm._s(
                                            _vm.filteredGraphicalAdDTOs.length
                                          ) +
                                          " out of " +
                                          _vm._s(_vm.graphicaladDTOs.length) +
                                          " Ad Placements "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col" }, [
                              _c("div", { staticClass: "card" }, [
                                _c("div", { staticClass: "table-responsive" }, [
                                  _c(
                                    "table",
                                    {
                                      staticClass:
                                        "table table-vcenter card-table table-striped",
                                    },
                                    [
                                      _vm._m(0),
                                      _c(
                                        "tbody",
                                        [
                                          _vm._l(
                                            _vm.displayGraphicalAdDTOs,
                                            function (graphicaladDTO) {
                                              return _c(
                                                "tr",
                                                { key: graphicaladDTO.rowid },
                                                [
                                                  _c("td", [
                                                    _c(
                                                      "div",
                                                      [
                                                        _vm._v(" View Ad "),
                                                        graphicaladDTO.image
                                                          ? _c(
                                                              "span",
                                                              {
                                                                attrs: {
                                                                  id:
                                                                    "popover_" +
                                                                    graphicaladDTO.rowid,
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "svg",
                                                                  {
                                                                    staticClass:
                                                                      "icon icon-tabler icon-tabler-info-circle",
                                                                    attrs: {
                                                                      xmlns:
                                                                        "http://www.w3.org/2000/svg",
                                                                      width:
                                                                        "24",
                                                                      height:
                                                                        "24",
                                                                      viewBox:
                                                                        "0 0 24 24",
                                                                      "stroke-width":
                                                                        "2",
                                                                      stroke:
                                                                        "currentColor",
                                                                      fill: "none",
                                                                      "stroke-linecap":
                                                                        "round",
                                                                      "stroke-linejoin":
                                                                        "round",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c("path", {
                                                                      attrs: {
                                                                        stroke:
                                                                          "none",
                                                                        d: "M0 0h24v24H0z",
                                                                        fill: "none",
                                                                      },
                                                                    }),
                                                                    _c(
                                                                      "circle",
                                                                      {
                                                                        attrs: {
                                                                          cx: "12",
                                                                          cy: "12",
                                                                          r: "9",
                                                                        },
                                                                      }
                                                                    ),
                                                                    _c("line", {
                                                                      attrs: {
                                                                        x1: "12",
                                                                        y1: "8",
                                                                        x2: "12.01",
                                                                        y2: "8",
                                                                      },
                                                                    }),
                                                                    _c(
                                                                      "polyline",
                                                                      {
                                                                        attrs: {
                                                                          points:
                                                                            "11 12 12 12 12 16 13 16",
                                                                        },
                                                                      }
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        graphicaladDTO.image
                                                          ? _c(
                                                              "b-popover",
                                                              {
                                                                attrs: {
                                                                  target:
                                                                    "popover_" +
                                                                    graphicaladDTO.rowid,
                                                                  triggers:
                                                                    "hover",
                                                                  placement:
                                                                    "right",
                                                                },
                                                              },
                                                              [
                                                                _c("img", {
                                                                  attrs: {
                                                                    src: graphicaladDTO.image,
                                                                  },
                                                                }),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "text-muted small",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  graphicaladDTO.width
                                                                ) +
                                                                " x " +
                                                                _vm._s(
                                                                  graphicaladDTO.height
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]),
                                                  _c("td", [
                                                    _c("div", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            graphicaladDTO.itemName
                                                          ) +
                                                          " "
                                                      ),
                                                    ]),
                                                  ]),
                                                  _c("td", [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "text-center",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              graphicaladDTO.impressions
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]),
                                                  _c("td", [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "text-center",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              graphicaladDTO.clicks
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]),
                                                  _c("td", [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "text-center",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              graphicaladDTO.actionRate
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]),
                                                ]
                                              )
                                            }
                                          ),
                                          _c("tr", [
                                            _vm._m(1),
                                            _vm._m(2),
                                            _c("td", [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "text-center font-weight-bold",
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(_vm.total_views) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]),
                                            _c("td", [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "text-center font-weight-bold",
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(_vm.total_clicks) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]),
                                            _c("td", [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "text-center font-weight-bold",
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.total_actionrate
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]),
                                          ]),
                                        ],
                                        2
                                      ),
                                    ]
                                  ),
                                ]),
                              ]),
                            ]),
                          ]),
                        ])
                      : _c("div", { staticClass: "container-xl" }, [
                          _c("span", [
                            _vm._v(
                              " No traffic activity has been collected yet, or you do not have any Graphical Advertisements. "
                            ),
                          ]),
                        ]),
                  ]),
                ]),
          ])
        : _c("div", { staticClass: "container-xl" }, [_vm._m(3)]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _c("th", [_vm._v("Placement")]),
        _c("th", { staticClass: "text-center" }, [_vm._v("Views")]),
        _c("th", { staticClass: "text-center" }, [_vm._v("Clicks")]),
        _c("th", { staticClass: "text-center" }, [_vm._v("CTR")]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("div", [_vm._v(" ")])])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("div", { staticClass: "text-right font-weight-bold" }, [
        _vm._v(" Total "),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col" }, [
        _c("h3", [_vm._v("Preparing graphical ad report...")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }